import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CignaIcon } from '@cigna/ui/icon';
import { CorrespondenceHistory } from '@cigna/chcp/claims/shared/util';

@Component({
  selector: 'cigna-correspondence-messages-list',
  templateUrl: './correspondence-messages-list.component.html',
  styleUrls: ['./correspondence-messages-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CorrespondenceMessagesListComponent {
  @Input() messages: CorrespondenceHistory[];
  @Input() isImpersonator = false;
  @Input() maxHeight = 680;

  @Output() openContentV2Url: EventEmitter<string> = new EventEmitter();

  CignaIcon = CignaIcon;

  public trackByFunc(index: number, message: CorrespondenceHistory): string {
    return message.claimId;
  }

  viewPDF(message: CorrespondenceHistory) {
    this.openContentV2Url.emit(message.documentLink);
  }
}
